export interface FlightDetails {
    confirmationID: string
    travelers: Traveler[]
    segments: Segment[]
    travelReady: boolean
    score: number
    keyAttributes: Object
    docCheckRegion: string
    globalirrops: string
    isIrrop: boolean
    isInternational: boolean
    multiplePnr: boolean
    canChangeFlight: boolean
    canRebookFlight: boolean
    allTravelers: Traveler[]
    data: Object
}

interface KeyAttribute {

}
interface FlightStatus {
    description: string;
    className: string;
}

interface StateCode {
    name: string;
}

interface IataCityCode {
    name: string;
    stateCode: StateCode;
}

interface IataCountryCode {
    _id?: any;
    name?: any;
    countryCode: string;
}


interface DepartureAirport {
    _id?: any;
    iataCode: string;
    name: string;
    iataCityCode: IataCityCode;
    iataCountryCode: IataCountryCode;
}

interface StateCode2 {
    name: string;
}

interface IataCityCode2 {
    name: string;
    stateCode: StateCode2;
}

interface IataCountryCode2 {
    _id?: any;
    name?: any;
    countryCode: string;
}

interface ArrivalAirport {
    _id?: any;
    iataCode: string;
    name: string;
    iataCityCode: IataCityCode2;
    iataCountryCode: IataCountryCode2;
    genre?: any;
}

export interface Segment {
    confirmationID: string
    activeFlightSegment: boolean
    segmentNumber: number
    flightNumber: number
    flightStatus: FlightStatus
    legStatus: string
    carrierCode: string
    carrierName: string
    departureAirport: DepartureAirport
    localSchDeptDtm: string
    departureDateTime: string
    departureDateTimeLong: number
    departureTerminal: string
    departureGate: string
    arrivalAirport: ArrivalAirport
    arrivalDateTime: string
    arrivalTerminal: string
    arrivalGate: string
    boardDateTime: string
    boardDateTimeLong: number
    travelTime: number
    baggageCarouselId: string
    effectiveHub: string
    isIrrop: boolean
    seatNumber: string
    isFinalDestination: boolean
}


/** Traveler */
interface Seat {
    seatNumber: string;
    segmentNumber: number;
}

export interface Traveler {
    givenName: string;
    surname: string;
    seats: Seat[];
    contactInfo?: any;
    isCheckedIn: string;
    bagStatus?: any;
    bagCount?: any;
    travelReadiness?: travelerReadiness[];
}

interface travelerReadiness {
    isTravelReady: boolean,
    segmentNo: number
}

export const newFlightSegment = (): Segment => ({
    confirmationID: '',
    activeFlightSegment: false,
    segmentNumber: 0,
    flightNumber: 0,
    flightStatus: null,
    legStatus: '',
    carrierCode: '',
    carrierName: '',
    departureAirport: null,
    localSchDeptDtm: '',
    departureDateTime: '',
    departureDateTimeLong: 0,
    departureTerminal: '',
    departureGate: '',
    arrivalAirport: null,
    arrivalDateTime: '',
    arrivalTerminal: '',
    arrivalGate: '',
    boardDateTime: '',
    boardDateTimeLong: 0,
    travelTime: 0,
    baggageCarouselId: '',
    effectiveHub: '',
    isIrrop: false,
    seatNumber: '--',
    isFinalDestination: false,
})
